export default "__VITE_ASSET__CefQPWi9__"